import {useLocation, useNavigate, useParams} from "react-router-dom";
import Header from "../../components/header";
import {useEffect, useState} from "react";
import Loader from "../../components/loader";
import Approval from "../../components/object/approval";
import {GetObject} from "../../api/objects/objects";
import ticketIcon from "../../icons/ticket.svg";
import arrowRightIcon from "../../icons/arrow-right.svg";

const HistoryLink = () => {
    const navigate = useNavigate()
    return <div className={"tickets"} onClick={e => {
        navigate("/objects/orders")
    }}>
        <div className={"tickets-icon"}>
            <img style={{width: 24, height: 24}} src={ticketIcon}/>
        </div>
        <div className={"tickets-title"}>
            <div className={"tickets-title-title"}>Мои оплаты</div>
            <div className={"tickets-title-subtitle"}>История оплат</div>
        </div>
        <div className={"tickets-link"}>
            <img style={{width: 24, height: 24}} src={arrowRightIcon}/>
        </div>
    </div>
}

export default ({verified}) => {
    const[loading,setLoading] = useState(false)
    const [object, setObject] = useState(null)
    const {id} = useParams()

    useEffect(() => {
        setLoading(true)
        GetObject(id).then(setObject).finally(()=>setLoading(false))
    }, []);

    return <div className={"page"}>
        <Loader visible={loading}/>
        <Header title={"Оплата"}/>
        {object && <Approval verified={verified} object={object} loading={loading} setLoading={setLoading}/>}
    </div>
}
